import APITemplate from './APITemplate'

export default APITemplate('/service-car')
